import React from "react";
const ButtonComponent=({item})=><button type="button" className="shrink-0 rounded-lg bg-[#272727] px-4 py-2 text-sm font-medium text-white transition hover:bg-[#3f3f3f]">{item}</button>;
export default ButtonComponent;
